export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 1c0 3.737.91 6.174 2.488 7.692C17.074 10.218 19.521 11 23 11v2c-3.479 0-5.926.782-7.512 2.308C13.911 16.826 13 19.263 13 23h-2c0-3.479-.782-5.926-2.308-7.512C7.174 13.911 4.737 13 1 13v-2c3.737 0 6.174-.91 7.692-2.488C10.218 6.926 11 4.479 11 1h2zm-.999 5.975c-.451 1.11-1.065 2.09-1.867 2.923-.87.904-1.926 1.6-3.163 2.102 1.237.502 2.293 1.198 3.163 2.102.801.832 1.416 1.812 1.867 2.922.502-1.235 1.198-2.29 2.1-3.158.833-.8 1.811-1.415 2.92-1.866-1.109-.451-2.087-1.065-2.92-1.866-.902-.869-1.598-1.923-2.1-3.16z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};